<template>
  <div class="cl-wrap">
    <div class="cl-head">
      <h4 class="cl-title"><CygnusIcon name="packages" /> Content library</h4>
      <p class="cl-sub">
        Write it once, reuse it everywhere. Shared text blocks (a standard footer, an
        "about us" paragraph) and rate-card prices live here; your email templates,
        proposals, landing pages and invoices pull them in when they render. Edit an
        entry here and every surface using it updates with it.
      </p>
      <p class="cl-hint">
        <strong>Blocks</strong> are reusable copy. <strong>Pricing</strong> is your rate
        card. Each one gets a short name you drop into a template - the exact syntax is
        shown on the editor below.
      </p>
    </div>

    <VendorContentLibraryAdmin />
  </div>
</template>

<script>
/**
 * ContentLibraryAdmin (Yorlin project override) — a header wrapper over the
 * vendor `@apexl/icarus-content-library` editor at /admin/content-library.
 *
 * Reported live: "the page subtitle renders a raw token — {contentLibrary.
 * pricing.<sku>} — in pink" and "I couldn't tell what this page is for".
 *
 * Reproduced in dev, and the token is NOT a broken interpolation: the vendor
 * subtitle deliberately documents the token SYNTAX inside `<code>` elements
 * (`&#123;contentLibrary.pricing.&lt;sku&gt;&#125;`), and Bootstrap paints
 * `code` in its pink #d63384. It renders exactly as authored — it simply
 * READS as a leaked template variable, and the sentence it sits in explains
 * the mechanism rather than the purpose, which is why the page looked broken
 * and unexplained at the same time.
 *
 * So the fix is editorial, not a rendering fix: lead with a plain-English
 * one-liner for what the page is FOR, and leave the token syntax where it is
 * genuinely useful — the inline form help under the Block-JSON field, where
 * someone is actually about to write one. The vendor header is hidden rather
 * than forked so the rest of the 380-line editor (both tabs, both CRUD forms)
 * stays vendor-owned and keeps updating with the package.
 *
 * Registered by NAME: icarus/src/index.js runs registerContentLibrary(app)
 * first and the ./components require.context afterwards, so this file wins the
 * `ContentLibraryAdmin` name — the same override route BrandAdmin.vue uses.
 * The vendor component is imported under a local alias so the override doesn't
 * mount itself recursively.
 */
import { ContentLibraryAdmin as VendorContentLibraryAdmin } from '@apexl/icarus-content-library';

export default {
  name: 'ContentLibraryAdmin',
  components: { VendorContentLibraryAdmin },
};
</script>

<style scoped lang="scss">
.cl-wrap {
  // The vendor ships its own header in the same idiom; ours replaces it.
  :deep(.content-library-admin__header) { display: none; }

  .cl-head { padding: 0.5rem 0.5rem 0; margin-bottom: 0.25rem; }
  .cl-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 1.25rem;
    font-weight: 650;
    margin-bottom: 6px;
    color: var(--m-text-primary, #16181d);
  }
  .cl-sub {
    color: var(--m-text-secondary, #4a4f5c);
    font-size: 0.875rem;
    max-width: 70ch;
    margin-bottom: 6px;
  }
  .cl-hint {
    color: var(--m-text-tertiary, #787f8c);
    font-size: 0.8125rem;
    max-width: 70ch;
    margin-bottom: 0;
  }
}
</style>
